import { useState } from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/Infrastructure/State';
import type { Address } from '@/modules/address/domain/Address';
import type { QueryHook } from '@/sections/shared/types/QueryHook';

export const selectDefaultAddress = createSelector(
  (state: RootState) => state.cart,
  (cart) => ({
    isLoading: !!cart?.isLoading,
    data: cart?.data?.shippingAddress as Address
  })
);

const useDefaultAddress = (): QueryHook<Address | undefined> => {
  const { isLoading, data } = useSelector(selectDefaultAddress);
  const [error] = useState('');

  return { data, isLoading, error };
};

export default useDefaultAddress;
